import {UserManagementConstants} from "constants";

const GC = window.__GENERATED_CONSTANTS__

export const WarningsMap = {
    [UserManagementConstants.WARNING_MANAGE_BALANCE_RIGHT_REVOKED]: "userlist.js.warning_manage_balance_right_revoked",
    [UserManagementConstants.WARNING_MANAGE_ACCOUNT_SETTINGS_RIGHT_REVOKED]: "userlist.js.warning_manage_account_settings_right_revoked",
    [UserManagementConstants.WARNING_PTO_FEATURE_DISABLED]: "userlist.js.warning_pto_feature_disabled",
    [UserManagementConstants.WARNING_SICK_FEATURE_DISABLED]: "userlist.js.warning_pto_feature_disabled"
}

export const AdditionalDataConstants = {
    MANAGE_ASSIGNMENTS_DATA: GC.UserManagementAdditionalData.MANAGEMENT_ASSIGNMENTS_COUNTERS,
    TEAM_ASSIGNMENTS_DATA: GC.UserManagementAdditionalData.TEAM_ASSIGNMENTS_DATA,
    USERS_WITHOUT_APPROVERS_DATA: GC.UserManagementAdditionalData.USERS_WITHOUT_APPROVERS_DATA,
    ALL_USERS_AUTOAPPROVED: GC.UserManagementAdditionalData.ALL_USERS_AUTOAPPROVED,
    MANAGEMENT_ASSIGNMENTS_COUNTERS: GC.UserManagementAdditionalData.MANAGEMENT_ASSIGNMENTS_COUNTERS,
    WORK_ASSIGNMENTS_COUNTERS: GC.UserManagementAdditionalData.WORK_ASSIGNMENTS_COUNTERS,
    ALL_ASSIGNED_INFO: GC.UserManagementAdditionalData.ALL_ASSIGNED_INFO,
    RATES: GC.UserManagementAdditionalData.RATES,
    CONCURRENTLY_REMOVED_ENTITIES: GC.UserManagementAdditionalData.CONCURRENTLY_REMOVED_ENTITIES,
    ACTIVE_LEAVE_TYPES: GC.UserManagementAdditionalData.ACTIVE_LEAVE_TYPES,
    TIME_ZONE_GROUPS_DATA: GC.UserManagementAdditionalData.TIME_ZONE_GROUPS_DATA
}

export const ErrorsExceptions = {
    NO_SUCH_USER: "com.actimind.actitime.administration.NoSuchUserException",
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/constants.js